export const SIZE = { tiny: 12, small: 16, medium: 24, large: 32, xlarge: 44 }
